import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import afterprint from '@mailobj-browser/front/js/events/types/afterPrint.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import rendered from '@mailobj-browser/front/js/tree/rendered.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { elements } from '../styles.js'
import { wrapper } from '#components/app/js/common/plugins/plugins.js'
import skin from '#utilities/js/ea/skin.js'
import { app } from '#utilities/js/ea/skins.js'

const skins = [app]

export const onClick = object(listener, {
  type: click,
  passive,
  task: button => {
    queueMicrotask(async () => {
      const { ownerDocument } = button
      const { body } = ownerDocument
      // email iframe
      const mailIframe = one(`.${elements.iframe} .${elements.iframe_iframe}:not([src])`, ownerDocument) ??
        one(`iframe#div_IN_PRE_MAIN.cl_MAIL_MSG_TEXT`, ownerDocument)

      if (mailIframe) {
        await rendered(mailIframe, body)

        const { contentWindow, contentDocument } = mailIframe

        if (skins.includes(skin)) {
          const { documentElement } = contentDocument
          const { outerHTML } = documentElement

          wrapper.printer.print(outerHTML)
        } else {
          contentWindow.print()
        }
      } else {
        globalThis.print()
      }
    })
  }
})

const onAfterPrint = object(listener, {
  type: afterprint,
  passive,
  task: () => {
    queueMicrotask(() => { // Garder pour bug Firefox qui déclenche afterprint en même temps que beforeprint
      const { ea_screen_adjust, ea_awake_abort } = globals
      ea_screen_adjust()
      if (ea_awake_abort)
        ea_awake_abort()
    })
  }
})

export default (
  button
) => {
  const { ownerDocument } = button
  const { defaultView } = ownerDocument

  onClick.listen(button)
  onAfterPrint.listen(defaultView)
}
